import type { SVGProps } from 'react'
const InfoTutorial = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22C13.2198 22 14.2084 20.9522 14.2084 19.6594V10.2968C14.2084 9.00398 13.2198 7.95615 12 7.95615C10.7802 7.95615 9.7915 9.00398 9.7915 10.2968V19.6594C9.7915 20.9522 10.7802 22 12 22Z"
      fill="white"
    />
    <path
      d="M9.86733 4.16197C9.84082 5.34088 10.6889 6.29586 11.9609 6.29586C13.286 6.29586 14.1333 5.34088 14.1341 4.16197C14.1068 2.92689 13.2853 2 11.9867 2C10.6889 2 9.84082 2.92611 9.86733 4.16197Z"
      fill="white"
    />
  </svg>
)
export default InfoTutorial
